import { type UseQueryResult, useQuery } from '@tanstack/react-query';

import { vouchersService } from '../../../services/vouchers.service';
import type { AssignedVoucher } from '../types/assignedVouchers.types';
import { mapVoucherSummaryToAssigned } from '../utilities/assignedVouchers.utils';

type Options = {
  enabled?: boolean;
  staleTimeMs?: number;
  gcTimeMs?: number;
};

export const useAssignedVouchersForCustomer = (
  appId: string | undefined,
  customerId: number | undefined,
  options?: Options
): UseQueryResult<AssignedVoucher[], unknown> => {
  const enabled = options?.enabled ?? (!!appId && !!customerId);
  const staleTime = options?.staleTimeMs ?? 5 * 60 * 1000;
  const gcTime = options?.gcTimeMs ?? 30 * 60 * 1000;

  return useQuery<AssignedVoucher[], unknown, AssignedVoucher[]>({
    queryKey: ['assignedVouchers', appId, customerId],
    enabled,
    staleTime,
    gcTime,
    retry: (failureCount, error: any) => {
      if (error?.response?.status && error.response.status >= 400 && error.response.status < 500) {
        return false;
      }
      return failureCount < 1;
    },
    queryFn: async () => {
      const summaries = await vouchersService.getCustomerVouchers(
        appId as string,
        customerId as number
      );
      return summaries.map((s) => mapVoucherSummaryToAssigned(s, customerId as number));
    },
  });
};
